module.exports = __webpack_public_path__ + "img/3-min.d51c8947.jpg";